import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsExcelService
    ,FvmsApiDtgGeoFenceService
    ,FvmsApiDtgTeamService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import {
    GeofenceConfFormComponent
} from "../form/geofence.conf.form.component";

@Component({
    selector: "geofence-conf-list"
    ,templateUrl: './geofence.conf.list.component.html'
    ,providers: []
})
export class GeofenceConfListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();
    listGeofence:any[];
    listTeam:any[];
    listCarType:any[];
    searchValue:string;
    @Input() listType:DtgListType = DtgListType.list;
    @Output() geofenceInfo = new EventEmitter();
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    userGroupId:number;
    dtgTeamId:string = "";
    dtgCarType:string = "0";
    useYn:string = "";

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsExcelService:FvmsExcelService
        ,private fvmsApiDtgGeoFenceService:FvmsApiDtgGeoFenceService
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.pagingInfo.pageSize = 15;

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.pagingInfo.curPage = 1;
                this.reloadListItem();
            });
     }

    ngOnInit() {
        this.reloadListItem();
        this.reloadListItemTeam();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    reloadListItem(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            // ,dtgTeamId : this.dtgTeamId
            ,searchValue : this.searchValue
            ,useYn : this.useYn
        };
        this.fvmsApiDtgGeoFenceService.listGeoFenceConf(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listGeofence = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                }
            });
    }

    // 셀렉트박스 그룹목록
    reloadListItemTeam(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : this.currentUserInfo.teamId
            ,searchValue : null
        };
        let pagingInfoTeam = {
            "curPage":1
            ,"pageSize":1000
        };
        this.fvmsApiDtgTeamService.getListTeam(searchInfo,pagingInfoTeam)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listTeam = apiResponse.resultValue;
                }
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    clickSelectGeofence(geofenceInfo:any){
        this.geofenceInfo.emit(geofenceInfo);
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItem();
    }

    clickSearch(){
        this.reloadListItem();
    }

    changeTeamInfo(event){
        this.reloadListItem();
    }

    changeCarType(event){
        this.reloadListItem();
    }

    changeUseYn(event){
        this.reloadListItem();
    }

    clickOpenModalGeofenceInfo(dtgActionType:DtgActionType,geofenceInfo:any){
        let modalRef = this.modalService.open(
            GeofenceConfFormComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );
        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.companyId = geofenceInfo?.companyId || this.companyInfo.companyId;
        modalRef.componentInstance.teamId = geofenceInfo?.dtgTeamId;
        modalRef.componentInstance.geoFenceId = geofenceInfo?.geoFenceId;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                case DtgActionType.update:
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                        this.clickSearch();
                    }
                    break;
                default:
                    break;
            }
        });
    }

    exportExcel(){

    }
}